import React from 'react'

const PresupuestarPage = () => {
  return (
    <div>
      <div className='w-full max-w-[1200px] mx-auto flex-wrap rounded-lg my-6'>
        <img
          src="/images/logos/logo_huequito.png"
          alt="Logo El Huequito - Pinturas"
          className='w-36 rounded-xl border-2 border-black'/>
        <h1 className='font-extrabold text-center text-xl'>PRESUPUESTO</h1>
      </div>
      
    </div>
  )
}

export default PresupuestarPage